import React from "react";
import styled from "styled-components";
import LifeAtModal from "../LifeAtModal";
import LifeAtModalContentRow from "../LifeAtModalContentRow";

const ModalContentImg = styled.img`
    height: 200px;
    width: auto;
    border-radius: 10px;
`;

interface LifeAtCTAModalProps {
    ctaTitle?: string;
    ctaSubtitle?: string;
    imageSrc?: string;
    actionButtons?: JSX.Element | JSX.Element[]; // 1+ LifeAtButton elements
    isOpen: boolean;
    closeModal: () => void;
}
export default function LifeAtCTAModal(props: LifeAtCTAModalProps) {
    const ctaChildren = [
        props.imageSrc && (
            <LifeAtModalContentRow key={`cta-modal-content-row-image`}>
                <ModalContentImg src={props.imageSrc} alt={""} />
            </LifeAtModalContentRow>
        ),
        props.actionButtons && (
            <LifeAtModalContentRow key={`cta-modal-content-row-action-buttons`}>
                {props.actionButtons}
            </LifeAtModalContentRow>
        ),
    ];

    return props.isOpen ? (
        <LifeAtModal
            title={props.ctaTitle}
            subtitle={props.ctaSubtitle}
            isOpen={props.isOpen}
            closeModal={props.closeModal}
        >
            {ctaChildren}
        </LifeAtModal>
    ) : null;
}
